import {get, post} from "./index";
import {applicationName} from "../utils";

/**
 * 获取任务的列表数据
 * @param url
 * @param param
 * @param callBack
 */
export const getNewActivityDataList = (url,param, callBack) => {
    post(url, param, callBack);
};

/**
 * 获取媒体信息
 * @param url
 * @param param
 * @param callBack
 */
export const getAllMedias=(param,callBack)=>{
   get("/cm-sites-"+applicationName() +"/media/getAll",{},callBack);
}

/**
 * 删除任务
 * @param url
 * @param param
 * @param callBack
 */
export const deleteInterview=(param,callBack)=>{
    post("/cm-sites-"+applicationName() +"/interview/delete",param,callBack);
}

/**
 * 获取所属项目 列表数据
 * @param url
 * @param param
 * @param callBack
 */
export const getComActivities=(param,callBack)=>{
    post("/cm-sites-"+applicationName() +"/interviewEvent/list",param,callBack);
}

/**
 * 发布采访任务
 * @param params
 * @returns {Promise<any>}
 */
export const publishNewActivity = (params)=>{
    return new Promise((resolve, reject) => {
        window.$.ajax({
            type:"post",
            async:false,
            url: "/cm-sites-"+applicationName() +"/interview/publish",
            traditional: true,//参数中有数组，防止深度序列化
            data:params,
            success:function (res) {
                resolve(res);
            },error:(err)=>{
                reject(err);
            }
        });
    });
};


/**
 * 根据resourceId获取资源
 * @param attachmentIds
 * @returns {Promise<any>}
 */
export const getAttachmentFiles = (attachmentIds)=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/interview/getAttachmentFiles";
    let params = {
        attachmentIds
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        traditional: true,//参数中有数组，防止深度序列化
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject(e);
        }
    });
})

/**
 * 获取采访任务
 * @param interviewId
 * @returns {Promise<any>}
 */
export const getById = (interviewId)=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/interview/getById";
    let params = {
        interviewId
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject(e);
        }
    });
})

/**
 * 添加媒体组合
 * @param mediaGroup
 * @returns {Promise<any>}
 */
export const addMediaGroup = (mediaGroup)=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/mediaGroup/add";
    let params = JSON.stringify(mediaGroup);
    window.$.ajax({
        type:"post",
        url: url,
        contentType:"application/json",
        data:params,
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject(e);
        }
    });
})

/**
 * 获取媒体组合
 * @param id
 * @returns {Promise<any>}
 */
export const getMediaGroupById = (id)=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/mediaGroup/getById";
    let params = {
        id
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject(e);
        }
    });
})

/**
 * 删除媒体组合
 * @param name
 * @returns {Promise<any>}
 */
export const delMediaGroupByName = (name)=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/mediaGroup/delByName";
    let params = {
        name
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject(e);
        }
    });
})

/**
 * 获取所有媒体组合
 * @param id
 * @returns {Promise<any>}
 */
export const getAllMediaGroup = ()=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/mediaGroup/getAll";
    window.$.ajax({
        type:"post",
        url: url,
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject(e);
        }
    });
})

export const getNewActivityWeekDayInfo=(param,callBack)=>{
    post("/cm-sites-"+applicationName() +"/interview/getDayAndWeekDynamicInfo",param,callBack);
}

/**
 * 根据线索id获取任务
 * @param param
 * @param callBack
 */
export const getByClueId = (clueId)=> new Promise((resolve, reject) => {
    let time = new Date().getTime();
    let url = "/cm-sites-"+applicationName() +"/interview/getByClueId";
    let params = {
        clueId,time
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        success:function (result) {
            if(result){
                resolve(result);
            }else{
                reject({});
            }
        },
        error:function (e) {
            console.error(e);
            reject({});
        }
    });
});

